import { render } from "./FuturesOrder.vue?vue&type=template&id=7bff99e2&scoped=true"
import script from "./FuturesOrder.vue?vue&type=script&lang=js"
export * from "./FuturesOrder.vue?vue&type=script&lang=js"

import "./FuturesOrder.vue?vue&type=style&index=0&id=7bff99e2&lang=scss&scoped=true"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bff99e2"]])

export default __exports__